import { jsxs as e, jsx as a } from "react/jsx-runtime";
const h = (l) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentcolor",
          d: "M18.692 2.063a1 1 0 1 0-2 0 1.4 1.4 0 0 1-1.4 1.4q-.053 0-.103.006a1 1 0 0 0 .102 1.994 1.4 1.4 0 0 1 1.4 1.4 1 1 0 1 0 2 0 1.4 1.4 0 0 1 1.4-1.4 1 1 0 1 0 0-2 1.4 1.4 0 0 1-1.4-1.4M22.292 9.263a1 1 0 1 0-2 0v.2h-.2a1 1 0 1 0 0 2h.2v.2a1 1 0 1 0 2 0v-.2h.2a1 1 0 1 0 0-2h-.2z"
        }
      ),
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M5.663 3.464h6.8a3.001 3.001 0 0 0 2.28 3.95 3 3 0 0 0 2.418 2.403 3.01 3.01 0 0 0 1.487 3.277v5.37a3 3 0 0 1-3 3H5.663a3 3 0 0 1-3-3v-12a3 3 0 0 1 3-3m2.065 4a1 1 0 1 0 0 2h2.982a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h5.982a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h5.982a1 1 0 1 0 0-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
export {
  h as default
};
